import React, { Component } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import axios from "axios";
import moment from "moment";
import NumberFormat from "react-number-format";
import { APIURL } from "../../config/config";
import Loading from "../../components/Loading";
import { format } from "date-fns";
import {
  border,
  contentBoldStyle,
  contentStyle,
} from "../../utils/exceljsStyles";

class SaleSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      financeData: [],
      locationData: [],
      carTypeData: [],
      isLoading: false,
    };

    this.toggleTab = this.toggleTab.bind(this);
    this.loadAllData = this.loadAllData.bind(this);
    this.renderFinanceTable = this.renderFinanceTable.bind(this);
    this.renderLocationTable = this.renderLocationTable.bind(this);
    this.renderCarTypeTable = this.renderCarTypeTable.bind(this);
    this.exportExcel = this.exportExcel.bind(this);
  }

  componentDidMount() {
    this.loadAllData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.dateStart !== this.props.dateStart ||
      prevProps.dateEnd !== this.props.dateEnd
    ) {
      this.loadAllData();
    }
  }

  loadAllData() {
    if (!this.props.dateStart || !this.props.dateEnd) {
      return;
    }

    this.setState({ isLoading: true });

    const data = {
      start_date: moment(this.props.dateStart).format("YYYY-MM-DD"),
      end_date: moment(this.props.dateEnd).format("YYYY-MM-DD"),
    };

    Promise.all([
      axios.post(APIURL + "/report/sell/summary/finance", data),
      axios.post(APIURL + "/report/sell/summary/location", data),
      axios.post(APIURL + "/report/sell/summary/cartype", data),
    ])
      .then(([financeRes, locationRes, carTypeRes]) => {
        this.setState({
          financeData: financeRes.data || [],
          locationData: locationRes.data || [],
          carTypeData: carTypeRes.data || [],
          isLoading: false,
        });
      })
      .catch((error) => {
        console.error("Error loading summary data:", error);
        this.setState({
          financeData: [],
          locationData: [],
          carTypeData: [],
          isLoading: false,
        });
      });
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  renderFinanceTable() {
    if (this.state.isLoading) {
      return <Loading />;
    }

    const totalSales = this.state.financeData.reduce(
      (sum, item) => sum + item.total_sales,
      0
    );

    return (
      <div className="card">
        <div className="card-header">
          <strong className="text-title">สรุปการขายตามไฟแนนซ์</strong>
        </div>
        <div className="card-block">
          <table className="table table-striped table-md">
            <thead>
              <tr>
                <th className="text-center" style={{ width: "25%" }}></th>
                <th className="text-left" style={{ minWidth: "25%" }}>
                  ไฟแนนซ์
                </th>
                <th className="text-center" style={{ minWidth: "25%" }}>
                  จำนวน (คัน)
                </th>
                <th className="text-center" style={{ width: "25%" }}></th>
              </tr>
            </thead>
            <tbody>
              {this.state.financeData.map((item, index) => (
                <tr key={index}>
                  <td></td>
                  <td className="text-left">{item.bank_name || "เงินสด"}</td>
                  <td className="text-center">
                    <NumberFormat
                      value={item.total_sales}
                      displayType="text"
                      thousandSeparator={true}
                    />
                  </td>
                  <td></td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="table-info">
                <th className="text-center" style={{ width: "25%" }}></th>
                <th className="text-left" style={{ minWidth: "25%" }}>
                  รวมทั้งหมด
                </th>
                <th className="text-center" style={{ minWidth: "25%" }}>
                  <NumberFormat
                    value={totalSales}
                    displayType="text"
                    thousandSeparator={true}
                  />
                </th>
                <th className="text-center" style={{ width: "25%" }}></th>
              </tr>
            </tfoot>
          </table>
        </div>

        {this.state.financeData.length === 0 && (
          <div className="text-center text-muted p-3">
            ไม่มีข้อมูลการขายในช่วงเวลาที่เลือก
          </div>
        )}
      </div>
    );
  }

  renderLocationTable() {
    if (this.state.isLoading) {
      return <Loading />;
    }

    const totalSales = this.state.locationData.reduce(
      (sum, item) => sum + item.total_sales,
      0
    );

    return (
      <div className="card">
        <div className="card-header">
          <strong className="text-title">
            สรุปการขายจากข้อมูลลูกค้าตามจังหวัดและอำเภอ
          </strong>
        </div>
        <div className="card-block">
          <table className="table table-striped table-md">
            <thead>
              <tr>
                <th className="text-center" style={{ width: "20%" }}></th>
                <th className="text-left" style={{ minWidth: "25%" }}>
                  จังหวัด
                </th>
                <th className="text-left" style={{ width: "20%" }}>
                  อำเภอ
                </th>
                <th className="text-center" style={{ minWidth: "20%" }}>
                  จำนวน (คัน)
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.locationData.map((item, index) => (
                <tr key={index}>
                  <td></td>
                  <td>{item.province_name || "ไม่ระบุ"}</td>
                  <td>
                    <span
                      className={
                        item.district_name === "ไม่ระบุ" ? "text-muted" : ""
                      }
                    >
                      {item.district_name}
                    </span>
                  </td>
                  <td className="text-center">
                    <NumberFormat
                      value={item.total_sales}
                      displayType="text"
                      thousandSeparator={true}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="table-info">
                <th className="text-center" style={{ width: "20%" }}></th>
                <th colSpan="2">รวมทั้งหมด</th>
                <th className="text-center" style={{ minWidth: "20%" }}>
                  <NumberFormat
                    value={totalSales}
                    displayType="text"
                    thousandSeparator={true}
                  />
                </th>
              </tr>
            </tfoot>
          </table>
        </div>

        {this.state.locationData.length === 0 && (
          <div className="text-center text-muted p-3">
            ไม่มีข้อมูลการขายในช่วงเวลาที่เลือก
          </div>
        )}
      </div>
    );
  }

  renderCarTypeTable() {
    if (this.state.isLoading) {
      return <Loading />;
    }

    const totalSales = this.state.carTypeData.reduce(
      (sum, item) => sum + item.total_sales,
      0
    );

    return (
      <div className="card">
        <div className="card-header">
          <strong className="text-title">สรุปการขายตามประเภทรถ</strong>
        </div>
        <div className="card-block">
          <table className="table table-striped table-md">
            <thead>
              <tr>
                <th className="text-center" style={{ width: "25%" }}></th>
                <th className="text-left" style={{ minWidth: "25%" }}>
                  ประเภทรถ
                </th>
                <th className="text-center" style={{ minWidth: "25%" }}>
                  จำนวน (คัน)
                </th>
                <th className="text-center" style={{ width: "25%" }}></th>
              </tr>
            </thead>
            <tbody>
              {this.state.carTypeData.map((item, index) => (
                <tr key={index}>
                  <td></td>
                  <td className="text-left">
                    {item.car_structure_name || "ไม่ระบุ"}
                  </td>
                  <td className="text-center">
                    <NumberFormat
                      value={item.total_sales}
                      displayType="text"
                      thousandSeparator={true}
                    />
                  </td>
                  <td></td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="table-info">
                <th className="text-center" style={{ width: "25%" }}></th>
                <th className="text-left" style={{ minWidth: "25%" }}>
                  รวมทั้งหมด
                </th>
                <th className="text-center" style={{ minWidth: "25%" }}>
                  <NumberFormat
                    value={totalSales}
                    displayType="text"
                    thousandSeparator={true}
                  />
                </th>
                <th className="text-center" style={{ width: "25%" }}></th>
              </tr>
            </tfoot>
          </table>
        </div>

        {this.state.carTypeData.length === 0 && (
          <div className="text-center text-muted p-3">
            ไม่มีข้อมูลการขายในช่วงเวลาที่เลือก
          </div>
        )}
      </div>
    );
  }

  exportExcel() {
    const { financeData, locationData, carTypeData } = this.state;

    // ตรวจสอบว่ามีข้อมูลหรือไม่
    if (!financeData.length && !locationData.length && !carTypeData.length) {
      alert("ไม่มีข้อมูลสำหรับ export");
      return;
    }

    this.setState({ isLoading: true });

    const ExcelJS = require("exceljs/dist/exceljs");
    const workbook = new ExcelJS.Workbook();

    // สร้างแท็บสำหรับไฟแนนซ์
    if (financeData.length > 0) {
      const financeSheet = workbook.addWorksheet("สรุปตามไฟแนนซ์");
      financeSheet.columns = [
        { header: "ไฟแนนซ์", key: "bank_name", width: 30 },
        { header: "จำนวน (คัน)", key: "total_sales", width: 15 },
      ];

      // เพิ่มข้อมูล
      financeData.forEach((item, index) => {
        financeSheet.addRow({
          bank_name: item.bank_name || "เงินสด",
          total_sales: item.total_sales,
        });
      });

      // เพิ่มแถวรวม
      const totalFinance = financeData.reduce(
        (sum, item) => sum + item.total_sales,
        0
      );
      financeSheet.addRow({
        bank_name: "รวมทั้งหมด",
        total_sales: totalFinance,
      });

      // จัดรูปแบบ
      financeSheet.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
          cell.border = border;
          cell.alignment = {
            vertical: "middle",
            horizontal: rowNumber === 1 || cell.col === 2 ? "center" : "left",
          };
          cell.font =
            rowNumber === 1 || rowNumber === financeSheet.rowCount
              ? contentBoldStyle
              : contentStyle;
        });
      });
    }

    // สร้างแท็บสำหรับจังหวัด/อำเภอ
    if (locationData.length > 0) {
      const locationSheet = workbook.addWorksheet("สรุปตามจังหวัด-อำเภอ");
      locationSheet.columns = [
        { header: "จังหวัด", key: "province_name", width: 20 },
        { header: "อำเภอ", key: "district_name", width: 20 },
        { header: "จำนวน (คัน)", key: "total_sales", width: 15 },
      ];

      // เพิ่มข้อมูล
      locationData.forEach((item) => {
        locationSheet.addRow({
          province_name: item.province_name || "ไม่ระบุ",
          district_name: item.district_name || "ไม่ระบุ",
          total_sales: item.total_sales,
        });
      });

      // เพิ่มแถวรวม
      const totalLocation = locationData.reduce(
        (sum, item) => sum + item.total_sales,
        0
      );
      locationSheet.addRow({
        province_name: "รวมทั้งหมด",
        district_name: "",
        total_sales: totalLocation,
      });

      // จัดรูปแบบ
      locationSheet.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
          cell.border = border;
          cell.alignment = {
            vertical: "middle",
            horizontal: cell.col === 3 ? "center" : "left",
          };
          cell.font =
            rowNumber === 1 || rowNumber === locationSheet.rowCount
              ? contentBoldStyle
              : contentStyle;
        });
      });
    }

    // สร้างแท็บสำหรับประเภทรถ
    if (carTypeData.length > 0) {
      const carTypeSheet = workbook.addWorksheet("สรุปตามประเภทรถ");
      carTypeSheet.columns = [
        { header: "ประเภทรถ", key: "car_structure_name", width: 30 },
        { header: "จำนวน (คัน)", key: "total_sales", width: 15 },
      ];

      // เพิ่มข้อมูล
      carTypeData.forEach((item) => {
        carTypeSheet.addRow({
          car_structure_name: item.car_structure_name || "ไม่ระบุ",
          total_sales: item.total_sales,
        });
      });

      // เพิ่มแถวรวม
      const totalCarType = carTypeData.reduce(
        (sum, item) => sum + item.total_sales,
        0
      );
      carTypeSheet.addRow({
        car_structure_name: "รวมทั้งหมด",
        total_sales: totalCarType,
      });

      // จัดรูปแบบ
      carTypeSheet.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
          cell.border = border;
          cell.alignment = {
            vertical: "middle",
            horizontal: cell.col === 2 ? "center" : "left",
          };
          cell.font =
            rowNumber === 1 || rowNumber === carTypeSheet.rowCount
              ? contentBoldStyle
              : contentStyle;
        });
      });
    }

    // สร้างไฟล์และดาวน์โหลด
    workbook.xlsx
      .writeBuffer()
      .then((data) => {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const curr = format(new Date(), "yyyyMMdd_HHmmss");
        const fileName = `sales_summary_${curr}.xlsx`;

        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = fileName;
        anchor.click();
        window.URL.revokeObjectURL(url);

        setTimeout(() => {
          this.setState({ isLoading: false });
        }, 1200);
      })
      .catch((error) => {
        console.error("Error creating Excel file:", error);
        alert("เกิดข้อผิดพลาดในการสร้างไฟล์ Excel");
        this.setState({ isLoading: false });
      });
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-block">
              <div className="row">
                <div className="col-6">
                  <strong>ข้อมูลการขาย</strong>&nbsp;&nbsp;
                  <span>
                    กรองตามวันที่ เลือกจากวันที่บล็อคด้านบนแล้วกดปุ่มตกลง
                  </span>
                </div>
                <div className="col-6">
                  <button
                    type="button"
                    className="float-right btn btn-success btn-sm"
                    onClick={() => this.exportExcel()}
                    disabled={this.state.isLoading}
                  >
                    <i className="fa fa-file-excel-o"></i> &nbsp; Export Excel
                  </button>
                </div>
              </div>

              <div className="mt-3">
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeTab === "1",
                      })}
                      onClick={() => this.toggleTab("1")}
                      style={{ cursor: "pointer" }}
                    >
                      สรุปตามไฟแนนซ์
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeTab === "2",
                      })}
                      onClick={() => this.toggleTab("2")}
                      style={{ cursor: "pointer" }}
                    >
                      สรุปตามจังหวัด/อำเภอ
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeTab === "3",
                      })}
                      onClick={() => this.toggleTab("3")}
                      style={{ cursor: "pointer" }}
                    >
                      สรุปตามประเภทรถ
                    </NavLink>
                  </NavItem>
                </Nav>

                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId="1">{this.renderFinanceTable()}</TabPane>
                  <TabPane tabId="2">{this.renderLocationTable()}</TabPane>
                  <TabPane tabId="3">{this.renderCarTypeTable()}</TabPane>
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SaleSummary;
